
import { ManualMatch, CreateManualMatchRequest } from "@/types/manualMatch";
import { ManualMatchApiClient } from "@/clients/manualMatchApiClient";

export class ManualMatchService {
  /**
   * Create a new manual match. Deliberately does NOT catch-and-swallow the underlying
   * ManualMatchApiClient rejection into `null` (issue #820) — `null` is indistinguishable from
   * "the API legitimately returned no match", and this is a real financial-state write. The
   * caller needs the rejection to know the write did not happen, matching
   * ReceivableService.acknowledgeExternalPayment's convention.
   */
  async createManualMatch(matchData: CreateManualMatchRequest): Promise<ManualMatch | null> {
    return await ManualMatchApiClient.createManualMatch(matchData);
  }

  /**
   * Delete a manual match. Same rationale as createManualMatch above (issue #820) — a swallowed
   * rejection collapsed to `false` is indistinguishable from "nothing was deleted".
   */
  async deleteManualMatch(matchId: string): Promise<boolean> {
    return await ManualMatchApiClient.deleteManualMatch(matchId);
  }
}
